import { render, staticRenderFns } from "./VesselGroupFilter.vue?vue&type=template&id=1818d7b6&scoped=true&"
import script from "./VesselGroupFilter.vue?vue&type=script&lang=ts&"
export * from "./VesselGroupFilter.vue?vue&type=script&lang=ts&"
import style0 from "./VesselGroupFilter.vue?vue&type=style&index=0&id=1818d7b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1818d7b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
